import * as React from 'react';

export const Contact = () => {
    return (
        <div className="container">
            <h2>Contact</h2>
            <h3>Officers</h3>
            <address>
                <strong>Commadore:</strong> <a href="mailto:swmalcolm@comcast.net">Scott Malcolm</a><br />
                <strong>Vice Commadore:</strong> <a href="mailto:allenj3304@gmail.com">Al Johnson</a>
            </address>

            <div>
                <h3>Keep in touch</h3>
                <p>Sign up for our Yahoo Group</p>
                <p><a href="mailto:cranne@yahoogroups.com">cranne@yahoogroups.com</a></p>
            </div>
        </div>
    );
}

export default Contact;
